import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getSubmittedForms, getVisitorInfo } from '../../store/app';
import {
  getTotalDownPayment,
  getSelectedCommunity,
  getSelectedLot,
  getTotalPrice,
  getTotalDueToday,
} from '../../store/build';
import useForm from '../../utils/useForm';
import { formatPrice, validateForm } from '../../utils/helpers';
import { submitOwner } from '../../utils/api';
import {
  Form,
  FormActionButton,
  FormAgreementContainer,
  FormDueToday,
  FormFootNote,
  FormPricing,
  Input,
  InputGroup,
  LinkStyleButton,
  ThankYou,
} from '../../styles/shared';
import { Link } from 'gatsby';
import {
  communityLotDataConfig,
  ownerModalContent,
} from '../../utils/dataConfig';
import { fontWeights } from '../../styles/theme';
import Checkbox from '../Checkbox';

const formName = 'owner';

const OwnerForm = () => {
  const [isBreakdownOpen, setBreakdownOpen] = useState(false);
  const [agreement, setAgreement] = useState({ show: false, checked: false });
  const handleAgreementCheckboxClick = e => {
    e.stopPropagation();
    setAgreement(prev => ({ ...prev, checked: !prev.checked }));
  };
  const handleShowAgreementOpenClick = e => {
    e.stopPropagation();
    setAgreement(prev => ({ ...prev, show: !prev.show }));
  };
  const [isSubmitting, setSubmitting] = useState(false);
  const visitorInfo = useSelector(getVisitorInfo);
  const formSubmitted = useSelector(getSubmittedForms).some(
    f => f === formName
  );
  const selectedLot = useSelector(getSelectedLot);
  const selectedCommunity = useSelector(getSelectedCommunity);
  const downPaymentTotal = useSelector(getTotalDownPayment);
  const totalPrice = useSelector(getTotalPrice);
  const totalDueToday = useSelector(getTotalDueToday);

  const { values, handleChange, handleBlur, handleSubmit, errors } = useForm(
    formName,
    visitorInfo,
    validateForm,
    isSubmitting,
    submitting => setSubmitting(submitting),
    submitOwner
  );
  return (
    <>
      <Form onSubmit={handleSubmit}>
        {formSubmitted ? (
          <ThankYou>{ownerModalContent.thankYouMessage}</ThankYou>
        ) : (
          <>
            <InputGroup>
              <p>First name</p>
              <Input
                type='text'
                name='firstName'
                onChange={handleChange}
                value={values.firstName}
                onBlur={handleBlur}
                required
                className={!!errors.firstName ? 'error' : ''}
              />
              <p className='error'>{errors.firstName}</p>
            </InputGroup>
            <InputGroup>
              <p>Last name</p>
              <Input
                type='text'
                name='lastName'
                onChange={handleChange}
                value={values.lastName}
                onBlur={handleBlur}
                required
                className={!!errors.lastName ? 'error' : ''}
              />
              <p className='error'>{errors.lastName}</p>
            </InputGroup>
            <InputGroup>
              <p>Email address</p>
              <Input
                type='email'
                name='email'
                onChange={handleChange}
                value={values.email}
                onBlur={handleBlur}
                required
                className={!!errors.email ? 'error' : ''}
              />
              <p className='error'>{errors.email}</p>
            </InputGroup>
            <InputGroup>
              <p>Phone number</p>
              <Input
                type='tel'
                name='phone'
                onChange={handleChange}
                value={values.phone}
                onBlur={handleBlur}
                className={!!errors.phone ? 'error' : ''}
              />
              <p className='error'>{errors.phone}</p>
            </InputGroup>
            <PricingArea>
              <div>
                <p className='note'>
                  Your fully-refundable deposit holds your reservation in the
                  order it was received. A Neu Team member will reach out to you
                  to confirm your reservation. You will be able to edit or
                  change your Neu Home before final confirmation.
                </p>
                {/*<p className='note'>*/}
                {/*  Your purchase of the{' '}*/}
                {/*  {communityLotDataConfig[selectedCommunity].title}{' '}*/}
                {/*  {*/}
                {/*    communityLotDataConfig[selectedCommunity].lots[selectedLot]*/}
                {/*      .title*/}
                {/*  }{' '}*/}
                {/*  Lot will require a {formatPrice(downPaymentTotal)} down*/}
                {/*  payment 30 days before move-in.*/}
                {/*</p>*/}
                {/*<PricingTable>*/}
                {/*<p>Estimated monthly payment:</p>*/}
                {/*<h4 className='total'>{formatPrice(totalPrice)}</h4>*/}
                {/*{isBreakdownOpen && (*/}
                {/*  <>*/}
                {/*    <p>Land payment</p>*/}
                {/*    <p>$2000</p>*/}
                {/*    <p>Unit payment</p>*/}
                {/*    <p>$400</p>*/}
                {/*    <p>HOA</p>*/}
                {/*    <p>$52</p>*/}
                {/*  </>*/}
                {/*)}*/}
                {/*</PricingTable>*/}
                {/*<LinkStyleButton*/}
                {/*  type='button'*/}
                {/*  onClick={() => setBreakdownOpen(prev => !prev)}*/}
                {/*>*/}
                {/*  {isBreakdownOpen ? 'hide' : 'view'} detail breakdown*/}
                {/*</LinkStyleButton>*/}
              </div>
              <FormDueToday>
                <h2>DUE TODAY</h2>
                <h1>{formatPrice(totalDueToday)}</h1>
              </FormDueToday>
            </PricingArea>
            <FormAgreementContainer>
              <Checkbox
                isChecked={agreement.checked}
                handleClick={handleAgreementCheckboxClick}
              >
                <p>
                  I agree to the{' '}
                  <button type='button' onClick={handleShowAgreementOpenClick}>
                    Neu Pre-Order Agreement
                  </button>
                </p>
              </Checkbox>
              {agreement.show && (
                <p className='agreement-text'>
                  I, (We) hereby deposit $100.00 to assure priority for unit
                  selection and membership application in Neu Community, a stock
                  cooperative. I (We) understand that this Reservation Agreement
                  constitutes assurance of priority consideration only in
                  accordance with the reservation number given upon receipt and
                  is not an agreement on my (our) part to complete all
                  membership requirements. I (We) understand that the
                  reservation process is the first part of becoming an owner at
                  Neu Community and that additional qualifying requirements must
                  be met. If I (we) do not wish to retain this reservation
                  priority, my (our) deposit is fully refundable upon written
                  request, and understand my (our) priority is then void. The
                  reservation deposit is non-interest bearing and will be
                  applied to the Share Payment at the time the Subscription
                  Agreement is signed.
                </p>
              )}
            </FormAgreementContainer>
            <FormActionButton
              type='submit'
              disabled={
                isSubmitting ||
                Object.keys(errors).length !== 0 ||
                !agreement.checked
              }
            >
              {isSubmitting ? 'Loading Payment Page...' : 'Pay Reservation Fee'}
            </FormActionButton>
            {errors.submission && (
              <p className='error' style={{ gridColumn: '1 / -1' }}>
                {errors.submission}
              </p>
            )}
          </>
        )}
      </Form>
      <FormFootNote>
        By clicking "Pay Reservation Fee" I agree to the{' '}
        <a href='/terms/' target='_blank'>
          Terms and Conditions
        </a>
        , the{' '}
        <a href='/privacy/' target='_blank'>
          Customer Privacy Agreement
        </a>
        , and consent to be contacted at the number provided with more
        information or offers about Neu products. I understand my consent to be
        contacted is not a condition of purchase.
      </FormFootNote>
    </>
  );
};
const PricingArea = styled(FormPricing)`
  column-gap: 0;
  .total {
    margin-bottom: 1rem;
    font-weight: ${fontWeights.medium};
  }
`;
const PricingTable = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 0.75rem;
  row-gap: 0.5rem;
  padding-bottom: 1rem;
  h4 {
    justify-self: start;
  }
`;
export default OwnerForm;
